export default __webpack_public_path__ + "static/B0059-13a9c5fb775fd47452552478242d4d6a.png";